export const defaultQueryConfig = {
  retry: 3,
  retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 10000),
  gcTime: 0,
  staleTime: 0
}
